import MenuItem from "@material-ui/core/MenuItem";
import TextField from "@material-ui/core/TextField";
import { useTranslation } from "react-i18next";
import { PAYMENT_TYPE } from "../../../constants";
import "./css/PaymentType.scss";
import { Controller, FieldError, UseFormMethods } from "react-hook-form";

interface IParams {
    control: UseFormMethods["control"];
    error: FieldError | undefined;
}

export const PaymentType = (props: IParams) => {
    const { control, error } = props;
    const { t } = useTranslation(["portin", "validation"]);

    return (
        <Controller
            control={control}
            name="paymentType"
            render={(renderProps) => (
                <TextField
                    className="xtest_account_type_input payment-type-field"
                    error={Boolean(error)}
                    helperText={error?.message}
                    id="payment-type"
                    inputRef={renderProps.ref}
                    label={`${t("portin:accountType")} *`}
                    margin="dense"
                    name={renderProps.name}
                    select
                    value={renderProps.value}
                    onChange={renderProps.onChange}
                >
                    {PAYMENT_TYPE.map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                            {option.label}
                        </MenuItem>
                    ))}
                </TextField>
            )}
            rules={{
                required: t("validation:required"),
            }}
        />
    );
};
